import { FunctionComponent, memo, useContext } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { ConfigContext, DetailsModalContext, UserContext } from '../../../../context';
import {
  NotificationDefault,
  StoryCardArticleContent,
  StoryCardQuoteContent,
} from '../../../../services';
import { layoutPath } from '../../../utils';
import { NotificationWrapper } from '../NotificationWrapper';
import { DefaultContent } from './DefaultContent';

interface DefaultProps {
  notification: NotificationDefault;
  setIsOpen: (isOpen: boolean) => void;
  logOpen: (notification_id: number) => void;
}

export const Default: FunctionComponent<DefaultProps> = memo(
  ({ notification, setIsOpen, logOpen }) => {
    const navigate = useNavigate();

    const { channelId } = useContext(UserContext).userInfo.userData;

    const { defaultLogoUrl } = useContext(ConfigContext).config.elements.notifications;

    const { setDetailsModalData } = useContext(DetailsModalContext);

    const { id, title, url, story, storyCard, message, deliveredTime } = notification;

    const hasLink = Boolean(url || (story && storyCard));

    const onClickHandler = () => {
      if (!hasLink) {
        return;
      }

      if (url) {
        window.open(url, '_blank', 'noreferrer');
      } else if (story && storyCard) {
        const { id: storyId, channelId: notificationChannelId } = story;
        const { id: cardId, content } = storyCard;

        if (notificationChannelId === channelId) {
          if (isMobileOnly) {
            navigate(layoutPath(`/details/${storyId}/${cardId}`));
          } else {
            setDetailsModalData({ storyId, cardId });
            setIsOpen(false);
          }
          return;
        }

        const { url } = content as StoryCardArticleContent | StoryCardQuoteContent;

        window.open(url, '_blank', 'noreferrer');
      }

      logOpen(id);

      setIsOpen(false);
    };

    return (
      <NotificationWrapper
        key={id}
        hasLink={hasLink}
        avatarUrl={defaultLogoUrl}
        deliveredTime={deliveredTime}
        onClick={onClickHandler}
      >
        <DefaultContent title={title} message={message} hasLink={hasLink} />
      </NotificationWrapper>
    );
  }
);
